<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/acknowledgments"><span class="item-title-text">Acknowledgments</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/lessoninflexibility" title="Link target outside of Sample"><span class="item-title-text">Lesson in Flexibility</span></span></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">1. </span><span href="#/chapter001" title="Link target outside of Sample"><span class="item-title-text">The Runaway Bride</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">2. </span><span href="#/chapter002" title="Link target outside of Sample"><span class="item-title-text">Home Sweet Home</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="item-title-text">What’s Done in the Dark</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="item-title-text">Onward Christian Soldiers</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="item-title-text">Ask for direction and divine guidance first</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="item-title-text">What’s the lesson in all of this?</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="item-title-text">Unexpected Occurrences</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">8. </span><span href="#/chapter008" title="Link target outside of Sample"><span class="item-title-text">Breaking Generational Curses</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">9. </span><span href="#/chapter009" title="Link target outside of Sample"><span class="item-title-text">Jennifer: The Lady of Jeffrey Manor</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">10. </span><span href="#/chapter010" title="Link target outside of Sample"><span class="item-title-text">My True Mother</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">11. </span><span href="#/chapter011" title="Link target outside of Sample"><span class="item-title-text">To forgive or Not to Forgive</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">12. </span><span href="#/chapter012" title="Link target outside of Sample"><span class="item-title-text">Merry Heart Centered Leadership</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/transformationbynaleighnakai" title="Link target outside of Sample"><span class="item-title-text">Transformation by Naleighna Kai</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/lovingmeforme" title="Link target outside of Sample"><span class="item-title-text">Loving Me for Me</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/mytimeinthesun" title="Link target outside of Sample"><span class="item-title-text">My Time in the Sun</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/kingofdevon" title="Link target outside of Sample"><span class="item-title-text">King of Devon</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/kingofdurabia" title="Link target outside of Sample"><span class="item-title-text">King of Durabia</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/themerryheartsinspirationalseries" title="Link target outside of Sample"><span class="item-title-text">The Merry Hearts Inspirational Series</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/alsobynaleighnakai" title="Link target outside of Sample"><span class="item-title-text">Also by Naleighna Kai</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/introducing" title="Link target outside of Sample"><span class="item-title-text">Introducing . . .</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ad7a1e5a